import React, { useEffect, useRef } from 'react';
import { Grid, Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SectionTab from 'constants/SectionTab';
import LoginRoot from 'modules/login';
import { MainColumn } from 'layouts/PodcastMain/container';
import { RightColumn } from 'layouts/RadioMain/container';
import Playbar from 'modules3/playbar';
import { formatDateTime } from 'common/ui/utils';
import container from './PodcastPage.container';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  mainAreaOffset: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
    paddingBottom: 160,
    background: theme.palette.bodyColor,
    color: theme.palette.textColor,
    [theme.breakpoints.down('md')]: {
      marginTop: 10
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 10
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 10
    }
  },
  mainColumn: {
    position: 'relative',
    maxWidth: '728px',
    width: '100%',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 70,
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      marginRight: 0
    }
  },
  rightColumn: {
    position: 'relative',
    width: '300px',
    marginLeft: '10px',
    marginRight: '10px'
  }
}));

const PodcastPage = (props) => {
  const classes = useStyles();
  const {
    userState: { profile },
    podcastState: {
      podcasts,
      episodes,
      genresPodcasts,
      podcastEpisodes,
      fiveStar,
      isPodCastClicked
    },
    playerPodCastState: {
      podcastid,
      episodeid,
      player: { playing }
    },
    userHistoryPodcastState: { heartedPodcastIds },
    podcastPlaylistState: { queue, queueEntry },
    onFetchInitialStart,
    onGetGenresStart,
    onFetchURLPodcastStart,
    onGetHeartsPodcastStart,
    onGetHistoryPodcastStart,
    onSetPodCastUrl,
    onSetAudioStatus,
    onAddPlayPodcastStart,
    onFavouritePodcast,
    onRemoveFavoritePodcastStart,
    onEpisodePlayerStart,
    onRatingHandleStart,
    onSetCurrentTab,
    onViewPodCastStart,
    onFetchPodCastEpisode,
    onSetCurrentViewdPodPlaylist,
    onQueuePodEpisodeId,
    onShowSnackbarNotification,
  } = props;
  const audioPlayer = useRef();
  const randomNumber = Math.floor(Math.random() * 4);
  const isFiveStar = fiveStar.some((id) => id === podcastid) ? 5 : randomNumber;

  useEffect(() => {
    if (!_.isEmpty(profile.uid)) {
      onGetHeartsPodcastStart();
      onGetHistoryPodcastStart();
      // onSetPodCastUrl();
    }
  }, [profile]);

  useEffect(() => {
    onFetchInitialStart();
    onGetGenresStart();
    const podcastValue = document.location.pathname
      .split('/')
      .slice(2, 3)
      .toString();
    if (podcastValue) {
      console.log('podcast_id>>>', podcastValue);
      onSetCurrentTab(SectionTab.PodCastDetail);
      onSetCurrentViewdPodPlaylist(podcastValue);
      onViewPodCastStart(podcastValue);
      onFetchPodCastEpisode(podcastValue);
    }
    /*const params = new URLSearchParams(window.location.search);
    const podcastURL = params.get('podcastid');
    const episodeURL = params.get('episodeid');
    if (podcastURL && episodeURL) {
      // console.log('podcastURL: ', podcastURL);
      // console.log('episodeURL: ', episodeURL);
      onFetchURLPodcastStart(podcastURL, episodeURL);
    }*/
  }, []);

  let episode;
  let title;
  let image;
  let subtitle;
  let length;
  if (episodeid && podcastEpisodes && podcastEpisodes[episodeid]) {
    episode = podcastEpisodes[episodeid] ?? episodes[episodeid];
    title = podcastEpisodes[episodeid].text
      ? podcastEpisodes[episodeid].text //static
      : podcastEpisodes[episodeid].title
        ? podcastEpisodes[episodeid].title //listennotes
        : podcastEpisodes[episodeid].name
          ? episodes[episodeid].name
          : ''; //apple
    image = genresPodcasts[podcastid].image
      ? genresPodcasts[podcastid].image //listennotes
      : genresPodcasts[podcastid].artworkUrl100
        ? genresPodcasts[podcastid].artworkUrl100 //apple
        : podcasts[podcastid].image;
    subtitle = podcastEpisodes[episodeid].subtext
      ? podcastEpisodes[episodeid].subtext //static
      : podcastEpisodes[episodeid].country
        ? podcastEpisodes[episodeid].country //listennotes
        : podcastEpisodes[episodeid].releaseDate
          ? formatDateTime(podcastEpisodes[episodeid].releaseDate)
          : ''; //aple
    length = podcastEpisodes[episodeid].topic_duration
      ? podcastEpisodes[episodeid].topic_duration //static
      : podcastEpisodes[episodeid].audio_length_sec
        ? podcastEpisodes[episodeid].audio_length_sec //listennotes
        : podcastEpisodes[episodeid].duration
          ? podcastEpisodes[episodeid].duration
          : 5000;
    if (
      podcastEpisodes[episodeid].duration &&
      podcastEpisodes[episodeid].duration.toString().includes(':')
    ) {
      const formater = podcastEpisodes[episodeid].duration.split(':');
      let totalSec;
      if (formater.length === 3) {
        totalSec = +formater[0] * 60 * 60 + +formater[1] * 60 + +formater[2];
      } else if (formater.length === 2) {
        totalSec = +formater[1] * 60 + +formater[2];
      }
      length = totalSec;
    }
  }

  return (
    <>
      <LoginRoot />
      <Grid container className={classes.mainAreaOffset}>
        <Grid item className={classes.mainColumn}>
          <MainColumn audioPlayer={audioPlayer} />
        </Grid>
        <Hidden mdDown>
          <Grid item className={classes.rightColumn}>
            <RightColumn />
          </Grid>
        </Hidden>
      </Grid>
      {episodeid && playing && (
        <Playbar
          id={episodeid}
          episode={episode}
          title={title}
          image={image}
          subtitle={subtitle}
          length={length}
          isFiveStar={isFiveStar}
          audioPlayer={audioPlayer}
          heartedPodcastIds={heartedPodcastIds}
          playlistEpisodeIds={queue}
          onSetAudioStatus={onSetAudioStatus}
          onAddPlayPodcastStart={onAddPlayPodcastStart}
          onFavouritePodcast={onFavouritePodcast}
          onRemoveFavoritePodcastStart={onRemoveFavoritePodcastStart}
          onEpisodePlayerStart={onEpisodePlayerStart}
          onRatingHandle={onRatingHandleStart}
          onShowSnackbarNotification={onShowSnackbarNotification}
          onQueuePodEpisodeId={onQueuePodEpisodeId}
          isPodCastClicked={isPodCastClicked}
        />
      )}
    </>
  );
};

export default container(PodcastPage);
